// eslint-disable-next-line import/no-extraneous-dependencies
import Vuex from 'vuex';
import { abTestModule, defaultFeedListPreLoadParams } from './modules/ab-test';
import { feedMoudle } from './modules/feed';
import { userModule } from './modules/user';
import { schemaModule } from './modules/schema';
import { isLogin } from '~/common/login';
import { conversationModule } from './modules/ai-conversation';
import { aiFeedMoudle } from './modules/ai-feed';
import { aiDiscoverMoudle } from './modules/ai-discover';
import { popupModule } from './modules/popup';

const createStore = () => {
    const store = new Vuex.Store({
        state: {
            startup: {},
            isLogin: false,
            videoList: [],
            clickedPicture: {},
            topicName: '',
            tgPraiseAmountList: [],
            host: '',
            /**
             * @zh 是否展示弹窗 - 引导用户打开通知的弹窗
             */
            showNotificationPopup: false,
            hasSwap: false,
        },
        mutations: {
            setStartup(state, data) {
                state.startup = data;
            },
            setIsLogin(state, data) {
                state.isLogin = data;
            },
            setVideoList(state, data) {
                state.videoList = data;
            },
            setClickedPicture(state, data) {
                state.clickedPicture = data;
            },
            setTopicName(state, data) {
                state.topicName = data;
            },
            setTgPraiseAmountList(state, data) {
                state.tgPraiseAmountList = data;
            },
            setHost(state, data) {
                state.host = data;
            },
            setShowNotificationPopup(state, data: boolean) {
                state.showNotificationPopup = data;
            },
            setHasSwap(state, data) {
                state.hasSwap = data;
            },
        },
        actions: {
            // 当csr时 无法调用这个
            async nuxtServerInit({ commit }, ctx) {
                const { $axios } = ctx;
                const res = await $axios.$$post('overseaAPI::/rest/o/w/pwa/startup', {
                    shareDeviceId: ctx.route?.query?.share_device_id,
                });

                // 拦截国内ip
                if (res.result === 5002) {
                    ctx.redirect('/error');
                }

                if (res.result === 1) {
                    commit('setStartup', res.data || {});
                    const {
                        FetchFeedListDefaultCount,
                        HoldPreVideoCount,
                        NextFeedListMinCount,
                        NextPreLoadVideoCount,
                        isDropLaunchApp,
                        openPwaafterInstall,
                        if_open_guide_to_desktop,
                        install_pwa_no_limit,
                        install_pwa_touch,
                        open_guide_seconds,
                        cache_exp,
                        isNewIOSFeedStrategy,
                        web_fission_enrty,
                    } = res.data || {};

                    commit('abTestModule/setABTestParams', {
                        FetchFeedListDefaultCount: Number(FetchFeedListDefaultCount || defaultFeedListPreLoadParams.FetchFeedListDefaultCount),
                        HoldPreVideoCount: Number(HoldPreVideoCount || defaultFeedListPreLoadParams.HoldPreVideoCount),
                        NextFeedListMinCount: Number(NextFeedListMinCount || defaultFeedListPreLoadParams.NextFeedListMinCount),
                        NextPreLoadVideoCount: Number(NextPreLoadVideoCount || defaultFeedListPreLoadParams.NextPreLoadVideoCount),
                        isDropLaunchApp: isDropLaunchApp === 'true',
                        openPwaafterInstall: Number(openPwaafterInstall || 5), // 秒
                        if_open_guide_to_desktop: if_open_guide_to_desktop === 'true',
                        install_pwa_no_limit: install_pwa_no_limit === 'true',
                        install_pwa_touch: install_pwa_touch === 'true',
                        open_guide_seconds: Number(open_guide_seconds || 5), // 秒
                        cache_exp: cache_exp === 'true',
                        isNewIOSFeedStrategy: isNewIOSFeedStrategy === '1',
                        web_fission_enrty: web_fission_enrty === 'true',
                    });
                }

                commit('setHost', ctx?.req?.headers?.host || '');
            },
            async getIsLogin({ commit }, ctx) {
                // const { $axios } = ctx
                const res = await isLogin();
                commit('setIsLogin', res);
            },
            // tg 打上金额列表
            async initTgPraiseAmounts({ commit, state }, ctx) {
                try {
                    const { $axios } = ctx;
                    const { result, errorMsg, data } = await $axios.$$post('https://m.kwai.com/rest/o/w/kconf/loggedOut', {
                        paths: ['overseaGrowth.newPushMessage.tgPayPraiseAmount'],
                    });
                    if (result === 1 && data?.['overseaGrowth.newPushMessage.tgPayPraiseAmount']) {
                        const tgPraiseAmountList = JSON.parse(data?.['overseaGrowth.newPushMessage.tgPayPraiseAmount']);
                        commit('setTgPraiseAmountList', tgPraiseAmountList);
                        console.log('tg miniApp: ', 'kconf fetch success');
                    }
                } catch (error) {
                    console.log(error);
                }
            },
        },
        modules: {
            abTestModule,
            feedMoudle,
            userModule,
            schemaModule,
            conversationModule,
            aiFeedMoudle,
            popupModule,
            aiDiscoverMoudle,
        },
    });
    return store;
};
export default createStore;
